// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__UkRRx","author":"Table_author__GDLs1","authorImage":"Table_authorImage__1ZPaK","unreadRow":"Table_unreadRow__1Jukg"};